import { t } from "../../i18n/runtime";

export function rarityScheme(selectedPct) {
  const data = {
    unique: {
      id: "unique",
      level: 9,
      class: "unique dark",
      word: t("rarity.unique.word"),
      emoji: "🔮",
      toolTip: t("rarity.unique.tip"),
      dark: true,
      emojiSquare: "🔮",
    },
    legendary: {
      id: "legendary",
      level: 7,
      class: "legendary",
      word: t("rarity.legendary.word"),
      emoji: "✨",
      toolTip: t("rarity.legendary.tip"),
      dark: true,
      emojiSquare: "🟪",
    },
    epic: {
      id: "epic",
      level: 5,
      class: "epic",
      word: t("rarity.epic.word"),
      emoji: "✨",
      toolTip: t("rarity.epic.tip"),
      dark: false,
      emojiSquare: "🟦",
    },
    rare: {
      id: "rare",
      level: 3,
      class: "rare",
      word: t("rarity.rare.word"),
      emoji: "✨",
      toolTip: t("rarity.rare.tip"),
      dark: false,
      emojiSquare: "🟨",
    },
    common: {
      id: "common",
      level: 1,
      class: "common",
      word: t("rarity.common.word"),
      emoji: null,
      toolTip: null,
      dark: false,
      emojiSquare: "🟩",
    },
  };

  if (selectedPct < 1) {
    return data["unique"];
  } else if (selectedPct <= 5) {
    return data["legendary"];
  } else if (selectedPct <= 10) {
    return data["epic"];
  } else if (selectedPct <= 20) {
    return data["rare"];
  }

  return data["common"];
}
